import { render } from "./ApplicationCreate.vue?vue&type=template&id=a772b6bc"
import script from "./ApplicationCreate.vue?vue&type=script&lang=js"
export * from "./ApplicationCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__